import type {
  IApiResponse,
  UserSavedPaymentMethodSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../../api/rtkqApi";
import { TagsType } from "../../constants";
import { standardRetryingRequestOptions } from "../../api/retrying";

export const rebillsApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getUserRebills: build.query<
      UserSavedPaymentMethodSerializer[],
      number[] | void
    >({
      query: paymentSystemIds => {
        const urlArgs = paymentSystemIds
          ? `?payment_system_ids=${paymentSystemIds.join(
              "&payment_system_ids="
            )}`
          : "";
        return {
          url: `/foundation/api/users/me/payments/rebills${urlArgs}`,
        };
      },
      providesTags: [TagsType.REBILLS],
      transformResponse: (
        response: IApiResponse<UserSavedPaymentMethodSerializer[]>
      ) => response.payload.data,
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
    deleteUserRebill: build.mutation<void, number>({
      query: rebillId => {
        return {
          url: `/foundation/api/users/me/payments/rebills/${rebillId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [TagsType.REBILLS],
    }),
  }),
});
